import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AssetContextService } from './asset-context.service';

@Injectable({
  providedIn: 'root',
})
export class AssetContextManager {
  private readonly router = inject(Router);
  private readonly assetContext = inject(AssetContextService);

  constructor() {
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe(event => {
      if (!event.url.startsWith('/assets/')) {
        this.assetContext.clearContext();
      }
    });
  }
}
